module.exports = __webpack_public_path__ + "img/benefit-03-cert-1.83f8b3a1.png";